(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/share.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/share.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.Share = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.tipset.templates.share(data);
    }
  });
})(Backbone, _, svs);

 })(window);